import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as BoxArrowUpRightSvg } from '../../assets/box-arrow-up-right-icon.svg';

export const BoxArrowUpRightIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={BoxArrowUpRightSvg} {...props} />;
};
